var map = {
	"./auth-routes.js": 6509,
	"./cbt-routes.js": 7858,
	"./general-routes.js": 7264,
	"./question-packages-routes.js": 4739,
	"./question-routes.js": 9490,
	"./review-routes.js": 8335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;